import { useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import type { GeneralFormProps } from '@/types/general';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../ui/form';
import { Image } from '../ui/image';
import { Input } from '../ui/input';

const FallbackAvatar = '/static/images/logos/logo-round.svg';

function RHFShadcnAvatarUploader({
  name,
  title,
  description,
  value: externalValue,
  onChange: externalOnChange,
  required,
}: GeneralFormProps) {
  const { control } = useFormContext();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleAvatarClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        const handleFileChange = (file: File) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64String = reader.result as string;

            const newEvent = { target: { value: base64String } };

            if (externalOnChange) {
              externalOnChange(newEvent);
            } else {
              field.onChange(newEvent);
            }
          };
          reader.readAsDataURL(file);
        };

        return (
          <FormItem className="w-full">
            <FormLabel>{title}</FormLabel>

            <Image
              src={
                (field.value as string)
                || (externalValue as string)
                || FallbackAvatar
              }
              alt="Avatar"
              className="mb-2 size-24 cursor-pointer rounded-full border object-cover"
              onClick={handleAvatarClick}
            />
            <FormControl>
              <Input
                type="file"
                id="avatar"
                accept="image/*"
                required={required}
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    handleFileChange(file);
                  }
                }}
                ref={fileInputRef}
                className="hidden"
              />
            </FormControl>
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
}

export default RHFShadcnAvatarUploader;
